import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regimen-step-man',
  templateUrl: './regimen-step-man.component.html',
  styleUrls: ['./regimen-step-man.component.scss']
})
export class RegimenStepManComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
